'use client';

import { Container, Heading } from '@mv/web-ui';
import { cva } from 'class-variance-authority';
import { useDataTags } from '@/modules/tracking/analytics/useDataTags';
import RichText from '@/payload/components/RichText/RichText';
import type { MobileTutorial, MobileTutorialBlock as Props } from '@/payload/types';
import MobileTutorialCard from './MobileTutorialCard';
import styles from './MobileTutorial.module.scss';

const cardsClasses = cva(styles.cards, {
	variants: {
		count: {
			1: styles.oneCard,
			2: styles.twoCards,
		},
	},
});

type MobileTutorialProps = Omit<Props, 'item'> & {
	tutorial: MobileTutorial;
};

export default function MobileTutorialBlock(props: MobileTutorialProps) {
	const { tutorial } = props;
	const { blockRef, labelRef, contentRef } = useDataTags(props.blockType, props.id);

	return (
		<Container>
			<section
				data-component="MobileTutorialBlock"
				id={props.navigationLabel ?? props.id ?? undefined}
				ref={blockRef}
				className={styles.layoutBlock}
			>
				<div className={styles.intro}>
					<Heading ref={labelRef} tag={'h2'} textAlignment={'center'}>
						{tutorial.title}
					</Heading>
					{tutorial.description && <RichText content={tutorial.description} />}
				</div>
				<div ref={contentRef} className={cardsClasses({ count: tutorial.cards?.length === 1 ? 1 : 2 })}>
					{tutorial.cards?.map(({ id, icon, cardTitle, targets }) => (
						<MobileTutorialCard key={id} icon={icon} cardTitle={cardTitle} targets={targets} />
					))}
				</div>
			</section>
		</Container>
	);
}
